import React from "react";
import { createRouter, RouterProvider } from "@tanstack/react-router";
import { routeTree } from "../routeTree.gen";

// Create a new router instance
export const router = createRouter({
  routeTree,
  defaultPreload: "intent",
  // Non-zero so hovering links doesn't re-run the root `beforeLoad` (and its
  // session check) for the same route on every intent. 0 meant every hover
  // re-evaluated the whole match chain — a get-session per hovered link.
  defaultPreloadStaleTime: 30_000,
  // Return referentially-stable selector results (useSearch/useParams/…) for
  // value-equal inputs. Without this, `useSearch()` handed back a new object on
  // every navigation, churning the data-table URL-sync memos/effects.
  defaultStructuralSharing: true,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Export the router provider component
export function WebRouterProvider() {
  return React.createElement(RouterProvider, { router });
}
